import template from './has-encumbrances.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
  .module('cian.addForm.hasEncumbrances', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectHasEncumbrances', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsHasNo;
    },
    controllerAs: 'hasEncumbrances',
    template,
  })).name;
